import ReactDOM from "react-dom";
import React, { useEffect } from "react";
import {
  createClient,
  ssrExchange,
  dedupExchange,
  cacheExchange,
  fetchExchange,
  Provider,
} from "urql";
import { getPage } from "vite-plugin-ssr/client";
import { PageWrapper } from "./PageWrapper";
import type { PageContext } from "./types";
import type { PageContextBuiltInClient } from "vite-plugin-ssr/types";
import { clientUrl } from "./_default.client-url";
import Wrap from "../pages/wrap";
import { Social } from "../pages/components/social";

import { inject } from "@vercel/analytics";

import Clarity from "@microsoft/clarity";

inject();
hydrate();
try {
  console.log("setup clarity: started");
  const projectId = "w1yddks1s6";
  Clarity.init(projectId);
  Clarity.event("");
  console.log("setup clarity: complete");
} catch (e) {
  console.error("error setting up clarity", e);
}

async function hydrate() {
  const pageContext = await getPage<PageContextBuiltInClient & PageContext>();
  let { Page, pageProps, urqlState } = pageContext;
  pageProps = { ...pageProps, routeParams: pageContext.routeParams };
  const client = createClient({
    // suspense: true,
    url: "https://g3so7nt7.api.sanity.io/v1/graphql/production/default",
    exchanges: [
      dedupExchange,
      cacheExchange,
      // We hydrate the page
      ssrExchange({ isClient: true, initialState: urqlState }),
      fetchExchange,
    ],
  });

  // useEffect(() => {  }, []);
  ReactDOM.hydrate(
    <PageWrapper pageContext={pageContext}>
      <Provider value={client}>
        <Page {...pageProps} />
      </Provider>
    </PageWrapper>,
    document.getElementById("page-view"),
  );
}
